import { Box, Typography, useMediaQuery } from "@mui/material";
import bannerImage from "../../assets/image/landing/banner.png";

const LandingBannerComponent = () => {

    const isSmallScreen = useMediaQuery('(max-width:600px)'); 


    return (
        <Box 
            style={{
                backgroundImage: `url(${bannerImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'bottom',
                height: isSmallScreen ? '100vh' : '95vh',
                position: 'relative',
                display: 'flex',
                justifyContent: 'flex-start', 
                padding: '20px',
            }}
        >
            <Box style={{ position: 'absolute', top: '12%', left: '6%', textAlign: 'start' }}>
                <Typography sx={{ color: '#fff', ml: 2,  fontSize: isSmallScreen ? '30px' : '60px', fontWeight: 'bold' }}>
                    ABOUT US
                </Typography>
                <Box 
                    sx={{ 
                        width: isSmallScreen ? '90%' : '50%', 
                        textAlign: 'justify',
                        color: '#fff',
                        mt: 10
                    }}
                >
                    <Typography sx={{ mb: 2,  fontSize: isSmallScreen ? '18px' : 28, }}>
                        Radix Group Inc. (RDX) is a private defense, technology, and infrastructure company in the Philippines. It collaborates with local and foreign partners to boost local production and to provide state-of-the-art technology, infrastructure, and defense solutions aligned with the Self-Reliant Defense Posture (SRDP) Republic Act 12024. 
                    </Typography>
                </Box>
                <Typography  sx={{ color: '#fff', mt: 10, ml: isSmallScreen ? 1 : 8, fontSize: isSmallScreen ? 20 : 43, fontWeight: 'bold'}}>
                    “Building a Stronger, Safer, and Self-Reliant Philippines.”
                </Typography>
            </Box>
        </Box>
    );
};

export default LandingBannerComponent;
